import { authHeader } from "@roman/shared/lib/auth/authHeader";
import type { RomanApiError } from "@roman/shared/lib/net/romanApi";
import romanApi from "@roman/shared/lib/net/romanApi";
import type { PhoneNumberActivationCodeRequest } from "@roman/shared/types/PhoneNumber";
import useSWRMutation from "swr/mutation";

const fetcher = (url: string, args: { arg: PhoneNumberActivationCodeRequest }) => {
  const headers = authHeader.getOrThrow();
  return romanApi.post<null, PhoneNumberActivationCodeRequest>(url, args.arg, { headers });
};

export const usePhoneNumberActivationCodeBase = (useHandleError: (msg: string) => (err: RomanApiError) => void) => {
  const handleError = useHandleError("認証に失敗しました。もう一度お試しください。");

  const { trigger } = useSWRMutation("/phone-number/activation-code", fetcher, {
    onError: (error) => {
      handleError(error);
    },
  });
  return {
    trigger,
  };
};
